import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../lib/crm-api';

const CrmAuthContext = createContext(null);

export const useCrmAuth = () => {
  const context = useContext(CrmAuthContext);
  if (!context) throw new Error('useCrmAuth must be used within CrmAuthProvider');
  return context;
};

export const CrmAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      const token = localStorage.getItem('crm_token');
      const savedUser = localStorage.getItem('crm_user');
      if (token && savedUser) {
        try {
          const response = await authAPI.getMe();
          setUser(response.data);
        } catch {
          localStorage.removeItem('crm_token');
          localStorage.removeItem('crm_user');
        }
      }
      setLoading(false);
    };
    initAuth();
  }, []);

  const login = async (email, password) => {
    const response = await authAPI.login(email, password);
    const { access_token, user: userData } = response.data;
    localStorage.setItem('crm_token', access_token);
    localStorage.setItem('crm_user', JSON.stringify(userData));
    setUser(userData);
    return userData;
  };

  const register = async (name, email, password) => {
    const response = await authAPI.register(name, email, password);
    const { access_token, user: userData } = response.data;
    localStorage.setItem('crm_token', access_token);
    localStorage.setItem('crm_user', JSON.stringify(userData));
    setUser(userData);
    return userData;
  };

  const logout = () => {
    localStorage.removeItem('crm_token');
    localStorage.removeItem('crm_user');
    setUser(null);
  };

  return (
    <CrmAuthContext.Provider value={{ user, loading, login, register, logout, isAuthenticated: !!user }}>
      {children}
    </CrmAuthContext.Provider>
  );
};
